import Icon from "@mdi/react";
import React, { useEffect, useState } from "react";
import { mdiAccountGroup, mdiStarHalfFull, mdiPodium, mdiChartLine, mdiCalendarMonth, mdiHome, mdiCog } from '@mdi/js';
import { useNavigate } from "react-router-dom";
import { _getGroupIcon } from "../../data/groups";
import { useCurrentGroupStore } from "../../stores/useCurrentGroupStore";

function GroupNameHeader({ groupId }) {
    const [headerImgUrl, setHeaderImgUrl] = useState('');

    const groupName = useCurrentGroupStore((state) => state.group?.groupName);
    const groupIcon = useCurrentGroupStore((state) => state.groupIcon);
    const groupHeader = useCurrentGroupStore((state) => state.group?.headerImage);

    const navigate = useNavigate();

    useEffect(() => {
        if (groupHeader) {
            import(`../../media/backgrounds/${groupHeader}.png`)
                .then(image => {
                    setHeaderImgUrl(image.default);
                })
                .catch(err => {
                    console.error("Failed to load background image", err);
                    setHeaderImgUrl(''); // Fallback to no image
                });
        }
    }, [groupHeader]);

    return (
        <>
            <style>
                {`
                    #groupNameHeader {
                    position: relative;
                    }

                    #groupNameHeader:before {
                    content: ' ';
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0.4;
                    background-image:  ${headerImgUrl ? `url(${headerImgUrl})` : 'none'};
                    background-repeat: no-repeat;
                    background-position: 50% 0;
                    background-size: cover;
                    }

                    .group-header-content {
                    position: relative;
                    }
                `}
            </style>
            <section id="groupNameHeader" className="hero is-extra-small  mb-2 mt-0">
                <div className="hero-body group-header-content">
                    <div className="mr-auto ml-auto has-text-weight-semibold has-text-grey-darker is-size-4 title">
                        <figure className="image is-48x48 ml-auto mr-auto is-size-7">
                            {groupIcon && groupIcon.length > 1 &&
                                <img src={groupIcon} alt="Group Icon" />
                            }
                        </figure>
                        {groupName || <span>&nbsp;</span>}
                    </div>
                </div>
                <div className="group-header-content is-hidden-mobile no-wrap is-hidden-tablet-only has-text-centered has-text-grey-darker has-text-weight-bold">
                    <div className="columns is-centered">
                        <div className="column is-1 has-text-centered " onClick={() => { navigate(`/group/${groupId}`) }}>
                            <span className="icon-text">
                                <span className="icon is-clickable">
                                    <Icon path={mdiHome} size={1.25} /><br />
                                </span>
                            </span>
                            <div className="block is-size-7 is-clickable">Group Home</div>
                        </div>
                        <div className="column is-1 has-text-centered " onClick={() => { navigate(`/logGame/${groupId}`) }}>
                            <span className="icon-text">
                                <span className="icon">
                                    <Icon path={mdiPodium} size={1.25} className="is-clickable" /><br />
                                </span>
                            </span>
                            <div className="block  is-size-7 is-clickable">Log Game</div>
                        </div>
                        <div className="column is-1 has-text-centered " onClick={() => { navigate(`/rateGames/${groupId}`) }}>
                            <span className="icon-text">
                                <span className="icon">
                                    <Icon path={mdiStarHalfFull} size={1.25} className="is-clickable" /><br />
                                </span>
                            </span>
                            <div className="block  is-size-7 is-clickable">Rate Games</div>
                        </div>
                        <div className="column is-1 has-text-centered  is-clickable" onClick={() => { navigate(`/groupSessions/${groupId}`) }}>
                            <span className="icon-text">
                                <span className="icon">
                                    <Icon path={mdiCalendarMonth} size={1.25} className="is-clickable" /><br />
                                </span>
                            </span>
                            <div className="block  is-size-7">All Sessions</div>
                        </div>
                        <div className="column is-1 has-text-centered " onClick={() => { navigate(`/groupMembers/${groupId}`) }}>
                            <span className="icon-text">
                                <span className="icon">
                                    <Icon path={mdiAccountGroup} size={1.25} className="is-clickable" /><br />
                                </span>
                            </span>
                            <div className="block  is-size-7 is-clickable">Members</div>
                        </div>
                        <div className="column is-1 has-text-centered " onClick={() => { navigate(`/gameStats/${groupId}`) }}>
                            <span className="icon-text">
                                <span className="icon">
                                    <Icon path={mdiChartLine} size={1.25} className="is-clickable" /><br />
                                </span>
                            </span>
                            <div className="block  is-size-7 is-clickable">Game Stats</div>
                        </div>
                        <div className="column is-1 has-text-centered " onClick={() => { navigate(`/groupSettings/${groupId}`) }}>
                            <span className="icon-text">
                                <span className="icon">
                                    <Icon path={mdiCog} size={1.25} className="is-clickable" /><br />
                                </span>
                            </span>
                            <div className="block  is-size-7 is-clickable">Settings</div>
                        </div>


                    </div>
                </div>
            </section>
        </>
    );
}

export default GroupNameHeader;